// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"805":"e1556f2d49664b62","915":"61b1afca5db6ce63"}[chunkId] + ".js";
};